import { useEffect, useState } from 'react';
import { Grid, Stack, TextField, Typography } from '@mui/material';

import Form from 'components/Form';
import { INames } from 'apis/main/type';
import { getNandaClass, getNandaDiagnosis } from 'apis/main';

interface Props {
  watch: any;
  setValue: any;
  register: any;
  disabled?: boolean;
  domainNames?: INames[];
  isTestMode?: boolean;
}

function Nanda(props: Props) {
  const { watch, register, setValue, domainNames, disabled, isTestMode } =
    props;

  const m_domain = watch('domain');

  // GetNandaClass
  const m_class = watch('class');
  const [classNames, setClassNames] = useState<INames[]>([]);
  useEffect(() => {
    if (!m_domain || m_domain === 'none') return setClassNames([]);
    getNandaClass({ domain: m_domain }).then(({ data }) => {
      setClassNames(data.names);
      setDiagnosisNames([]);
    });
  }, [m_domain]);

  // GetNandaDiagnosis
  const [diagnosisNames, setDiagnosisNames] = useState<INames[]>([]);
  useEffect(() => {
    if (!m_class || m_class === 'none') return setDiagnosisNames([]);
    getNandaDiagnosis({ domain: m_domain, class: m_class }).then(({ data }) => {
      setDiagnosisNames(data.names);
    });
  }, [m_domain, m_class]);

  // Render Select Options
  const getOptionValue = (option: INames) => option.eng;
  const getOptionLabel = (option: INames) => option.eng;

  const handlePreventEvent = (e: React.ClipboardEvent | React.MouseEvent) => {
    if (isTestMode) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <Stack spacing={2}>
      <Grid
        container
        wrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        spacing={0.75}
      >
        <Grid item xs={4}>
          <Typography variant="caption">領域 </Typography>
        </Grid>
        <Grid item xs={8}>
          <Form.MuiSelect
            isNone
            disabled={disabled}
            options={domainNames}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            {...register('domain')}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography variant="caption">類別</Typography>
        </Grid>
        <Grid item xs={8}>
          <Form.MuiSelect
            isNone
            disabled={disabled}
            options={classNames}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            value={watch('class')}
            {...register('class')}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography variant="caption">診斷</Typography>
        </Grid>
        <Grid item xs={8}>
          <Form.MuiSelect
            isNone
            disabled={disabled}
            options={diagnosisNames}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            value={watch('diagnosis')}
            {...register('diagnosis')}
          />
        </Grid>
      </Grid>

      <Form.Item label="主觀/客觀數據收集">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('collectingData')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="短期目標/長期目標">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('goal')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="護理計劃">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('plan')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="干預措施">
        <TextField
          // required
          fullWidth
          multiline
          minRows={5}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('interventions')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="護理評估">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('evaluation')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>
    </Stack>
  );
}

export default Nanda;
